import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "./AppSidebar";
import { TopBar } from "./TopBar";
import { useAuth } from "@/context/AuthContext";
import { CommandPalette } from "@/components/CommandPalette";
import { FeedbackLoopModal } from "@/components/FeedbackLoopModal";
import { useFeedbackLoop } from "@/hooks/useFeedbackLoop";

interface AppLayoutProps {
  children: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const {
    isOpen: feedbackOpen,
    onDismiss: onFeedbackDismiss,
    onRespond: onFeedbackRespond,
  } = useFeedbackLoop();

  useEffect(() => {
    if (!user) navigate("/login");
  }, [user, navigate]);

  if (!user) return null;

  return (
    <SidebarProvider>
      <CommandPalette />
      <FeedbackLoopModal
        open={feedbackOpen}
        onDismiss={onFeedbackDismiss}
        onRespond={onFeedbackRespond}
      />
      <div className="min-h-screen flex w-full">
        <AppSidebar />
        <div className="flex-1 flex flex-col min-w-0">
          <TopBar />
          <main className="flex-1 overflow-auto">{children}</main>
        </div>
      </div>
    </SidebarProvider>
  );
}

export function ManagerRoute({ children }: AppLayoutProps) {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && user.role !== "Manager") navigate("/client-profile", { replace: true });
  }, [user, navigate]);

  if (!user || user.role !== "Manager") return null;

  return <>{children}</>;
}
